import React from 'react';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Política de Privacidade - Cerveja Delivery</title>
      </Helmet>
      <div className="min-h-screen bg-cream-300 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-soft p-8 sm:p-12">
          <h1 className="font-display font-bold text-3xl sm:text-4xl text-dark-900 mb-8">Política de Privacidade</h1>
          
          <div className="prose prose-amber max-w-none text-dark-600">
            <p className="text-sm text-dark-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
            
            <p>
              Sua privacidade é importante para nós. Esta política explica como coletamos, usamos e protegemos seus dados.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">1. Dados Coletados</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Dados de Cadastro:</strong> Nome, email, telefone e senha criptografada.</li>
              <li><strong>Dados de Entrega:</strong> Endereços salvos para facilitar seus pedidos.</li>
              <li><strong>Dados de Navegação:</strong> Cookies técnicos para manter sua sessão ativa.</li>
            </ul>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">2. Compartilhamento de Dados</h3>
            <p>
              Compartilhamos o estritamente necessário apenas com as <strong>Cervejarias Parceiras</strong> quando você realiza um pedido, para que elas possam processar a entrega (Nome, Endereço, Telefone e Itens do Pedido).
            </p>
            <p>
              Não vendemos seus dados para terceiros para fins de marketing.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">3. Segurança</h3>
            <p>
              Utilizamos criptografia SSL em todas as comunicações. Seus dados de pagamento são processados diretamente pelo gateway (Stripe) e não são armazenados em nossos servidores.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">4. Seus Direitos</h3>
            <p>
              Você pode solicitar a exclusão da sua conta e de todos os seus dados a qualquer momento através do seu painel de usuário ou entrando em contato com o suporte.
            </p>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-center">
                Para exercer seus direitos de titular de dados, contate: privacidade@cerveja.delivery
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;